 console.log("document loading");
$(document).ready(function () {

  console.log("VAT script loaded + document ready");

  var lastSubtotalText = null;
  var subtotalObserver = null;

  function parseDKCurrency(txt) {
    console.log("Parsing currency:", txt);
    var cleaned = txt.replace(/[^\d.,-]/g, '').trim();
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    var val = parseFloat(cleaned);
    console.log("Parsed number:", val);
    return isNaN(val) ? null : val;
  }

  function formatDK(val) {
    console.log("formatDK:", val);
    return new Intl.NumberFormat('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(val) + ' kr';
  }

  function getSubtotalEl() {
    var el = document.querySelector('.cart-subtotal .money[data-cart-total]') 
         || document.querySelector('.cart-subtotal [data-cart-total]')
         || document.querySelector('.cart-subtotal .money');

    console.log("getSubtotalEl ->", el);
    return el;
  }

  function recalc() {
    console.log("recalc triggered");

    var subtotalEl = getSubtotalEl();
    if (!subtotalEl) {
      console.log("subtotal element not found");
      return;
    }

    var subtotalText = subtotalEl.textContent.trim();
    console.log("subtotal text:", subtotalText);

    if (!subtotalText || subtotalText === lastSubtotalText) {
      console.log("subtotal unchanged / empty, abort");
      return;
    }

    var subtotal = parseDKCurrency(subtotalText);
    if (subtotal == null) {
      console.log("subtotal did not parse");
      return;
    }

    var vat = subtotal * 0.25 / 1.25;
    console.log("VAT calculated:", vat);

    var taxEl = document.querySelector('.cart-taxes .tax-money');
    console.log("taxEl:", taxEl);

    if (taxEl) taxEl.textContent = formatDK(vat);

    var totalEl = document.querySelector('.cart-total .cart-orderTotal');
    console.log("totalEl:", totalEl);

    if (totalEl) totalEl.textContent = subtotalText;

    lastSubtotalText = subtotalText;
  }

  function observeSubtotalEl() {
    console.log("observeSubtotalEl called");
    var el = getSubtotalEl();
    if (!el) {
      console.log("no subtotal element to observe");
      return false;
    }

    console.log("attach MutationObserver to subtotal element:", el);

    if (subtotalObserver) subtotalObserver.disconnect();

    subtotalObserver = new MutationObserver(function () {
      console.log("subtotal MutationObserver fired");
      recalc();
    });

    subtotalObserver.observe(el, {
      characterData: true,
      childList: true,
      subtree: true
    });

    recalc();
    return true;
  }

  observeSubtotalEl();

  var container = document.querySelector('.cart-subtotal') || document.body;
  var reattach = null;

  new MutationObserver(function () {
    console.log("cart-subtotal container mutated → reattach?");
    if (reattach) clearTimeout(reattach);
    reattach = setTimeout(function () {
      observeSubtotalEl();
    }, 20);
  }).observe(container, { childList: true, subtree: true });

  recalc();

});

/* Tilføj til kurv funktionalitet */

jQuery(document).ready(function($){
  var $grid = $('.productgrid, [data-product-grid], .collection--products').first();
  if (!$grid.length) $grid = $(document); // fallback

  var isAdding = false; // simple queue to avoid overlapping calls

  function refreshCartCount(){
    return $.getJSON('/cart.js').then(function(cart){
      $('[data-cart-count], .header-cart-count, [data-header-cart-count]').text(cart.item_count);
      return cart;
    });
  }

  $grid.on('click', '.productitem--action-atc', function(e){
    e.preventDefault();

    var $btn = $(this);
    if ($btn.data('locked')) return;        // prevent rapid double clicks
    $btn.data('locked', true);

    var variantId = $btn.data('variant-id');
    if (!variantId) { $btn.data('locked', false); return; }

    var payload = { id: variantId, quantity: Number($btn.attr('data-qty')) || 1 };
    var sellingPlan = $btn.attr('data-selling-plan');
    if (sellingPlan) payload.selling_plan = sellingPlan;

    // Save original text so we can restore it later
    var $textEl = $btn.find('.atc-button--text');
    var originalText = $textEl.text();

    // Change text and disable button
    $btn.prop('disabled', true);
    $textEl.text('Tilføjer...');

    var startTime = Date.now();
    var minLoadTime = 1500; // 1.5 seconds

    // Perform add to cart request
    var doAdd = function(){
      return $.ajax({ 
        type: 'POST', 
        url: '/cart/add.js', 
        data: payload, 
        dataType: 'json' 
      })
      .then(refreshCartCount)
      .then(function(){
        if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
          window.theme.cart.open();
        } else {
          $btn.addClass('added');
          setTimeout(function(){ $btn.removeClass('added'); }, 1200);
        }
      });
    };

    var finalize = function(){
      var elapsed = Date.now() - startTime;
      var remaining = Math.max(minLoadTime - elapsed, 0);

      setTimeout(function(){
        $btn.prop('disabled', false).data('locked', false);
        $textEl.text(originalText); // restore button text
        isAdding = false;
      }, remaining);
    };

    if (isAdding) {
      // simple micro-queue: wait a tick then try again
      var tryLater = setInterval(function(){
        if (!isAdding) { 
          clearInterval(tryLater); 
          isAdding = true; 
          doAdd().always(finalize); 
        }
      }, 50);
    } else {
      isAdding = true; 
      doAdd().always(finalize);
    }
  });
});
